export const combineTimeSeriesData = (timeSeresDataResults, viewport) => timeSeresDataResults.reduce((timeSeriesData, newTimeSeriesData) => {
    const { dataStreams, viewport, thresholds } = newTimeSeriesData;
    return {
        dataStreams: [...timeSeriesData.dataStreams, ...dataStreams],
        viewport,
        thresholds: [...timeSeriesData.thresholds, ...thresholds],
    };
}, { dataStreams: [], viewport, thresholds: [] });
